import { FadeInAnimation } from './fadeInAnimation';
import { FadeInDownAnimation } from './fadeInDownAnimation';
import { FadeInUpAnimation } from './fadeInUpAnimation';
export var ANIMATIONS = {
  'fade-in-up': FadeInUpAnimation,
  'fade-in-down': FadeInDownAnimation,
  'fade-in': FadeInAnimation
};